import { styled } from 'common/src/designSystem/components/stitches';

export const OrganizationSectionTitleMobile = styled('h3', {
    color: '$gray500',
    fontSize: '$textSm',
    margin: 0
});
